
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30935',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30935",
  "emoji-mart": "static-3.6",
  "feedback-schema": "static-1.55508",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8456",
  "hubspot-dlb": "static-2.1911",
  "HubStyleTokens": "static-2.11908",
  "I18n": "static-7.1692",
  "quartz": "static-1.7590",
  "quartz-config": "static-1.1368",
  "quartz-core": "static-1.6809",
  "react-dlb": "static-1.92",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.83",
  "reselect": "static-3.15",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.1039",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55495",
  "feedback-utils": "static-1.55499",
  "forms-embed-utils-lib": "static-1.4882",
  "forms-utils-lib": "static-1.13250",
  "foundations-assets": "static-1.5303",
  "foundations-components": "static-1.8658",
  "foundations-theming": "static-1.4899",
  "hub-http": "static-1.6626",
  "hubspot-url-utils": "static-1.4383",
  "HubStyle": "static-2.12215",
  "icons": "static-2.699",
  "immutable": "static-2.88",
  "quick-fetch": "static-1.4194",
  "raven": "static-3.5925",
  "react": "static-7.202",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.80",
  "react-rhumb": "static-1.17150",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5626",
  "react-virtualized": "static-2.111",
  "redux": "static-4.81",
  "StyleGuideUI": "static-3.513",
  "tinymce-plugins": "static-1.58410",
  "transmute": "static-2.97",
  "ui-images": "static-2.1269",
  "UIComponents": "static-3.8854",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9990",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.3867",
  "quartz-webpack": "static-1.3814",
  "foundations-theming-specialty": "static-1.2615",
  "property-description-translator": "static-1.4238",
  "HeadJS": "static-2.812",
  "framer-motion": "static-1.83",
  "hs-test-utils-bend-plugin": "static-1.3567",
  "msw": "static-1.39",
  "msw-config": "static-1.19",
  "testing-library": "static-1.163",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.233",
  "moment-timezone": "static-5.94",
  "jasmine": "static-4.4726",
  "jasmine-runner": "static-1.6867",
  "opentelemetry-fe-types": "static-1-aeastham-default-document-load-user-interaction.5",
  "dispatcher": "static-1.146",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.897",
  "hubspotter-http": "static-1.4931",
  "mobile-manifest-mixins": "static-1.595",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1-aeastham-default-document-load-user-interaction.5",
  "quartz-auth": "static-1.1265",
  "quartz-head": "static-1.1255",
  "quartz-i18n": "static-1.1265",
  "quartz-routing": "static-1.1020",
  "quartz-test": "static-1.1265",
  "quartz-tracking": "static-1.969",
  "trellis-components": "static-1.2971",
  "ui-fonts": "static-1.1170",
  "usage-tracker-container": "static-1.7721",
  "usage-tracker-core": "static-1.7581",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.306",
  "conversations-skeleton-state": "static-1.7602",
  "reference-resolvers": "static-1.8596",
  "sanitize-text": "static-1.8575",
  "PatternValidationJS": "static-1.3304",
  "ReduxMessenger": "static-2.10789",
  "outpost": "static-1.4552",
  "rpc-client-utils": "static-1.5087",
  "sanitize": "static-1.4891",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4927",
  "floating-ui": "static-1.67",
  "hs-story-utils": "static-1.9842",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.89",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.2952",
  "bend-plugin-foundations-theming": "static-1.3382",
  "foundations-theming-base": "static-1.3884",
  "stylex": "static-1.45",
  "hs-locale-management": "static-1.364",
  "csstype": "static-1.50",
  "web-vitals": "static-1.18",
  "ai-components-ui-library": "static-1.9923",
  "atom": "static-1.5495",
  "codemirror": "static-5.105",
  "content-assistance-lib": "static-1.8345",
  "ContentUtils": "static-1.69344",
  "data-token-picker": "static-1.17043",
  "file-manager-components": "static-1.24742",
  "FileManagerCore": "static-1.40241",
  "FileManagerLib": "static-1.40382",
  "frontend-preferences-client": "static-1.8335",
  "hub-http-contrib": "static-1.3445",
  "interframe": "static-3.5159",
  "layout-dnd-components": "static-1.13133",
  "layout-dnd-utils": "static-1.12108",
  "property-translator": "static-1.5797",
  "react-codemirror": "static-1.11057",
  "react-colorpicker": "static-2.10630",
  "reference-resolvers-lite": "static-1.8523",
  "rich-text-lib": "static-1.20470",
  "tinymce-data": "static-1.41381",
  "tinymce-themes": "static-1.57266",
  "ui-addon-emoji-picker": "static-1.10284",
  "ui-addon-sales-email": "static-1.5621",
  "ui-brand-identity-lib": "static-1.16793",
  "bender-build-tools": "static-1.3518",
  "opentelemetry-web": "static-1.18",
  "beacon-keepalive-queue": "static-1.117",
  "hub-http-shared-msw-handlers": "static-1.10807",
  "hubspotter-http-shared-msw-handlers": "static-1.10805",
  "usage-tracker-session-replay": "static-1.5417",
  "base-ui": "static-1.26",
  "react-day-picker": "static-1.14",
  "trellis-theming": "static-1.1401",
  "tanstack-virtual": "static-1.42",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.497",
  "chirp-fetch": "static-1.2318",
  "stylex-utils": "static-1.160",
  "chatspot-core": "static-1.23502",
  "copilot-toolkit": "static-1.12044",
  "customer-data-objects-ui-components": "static-1.13447",
  "data-fetching-client": "static-1.10063",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5176",
  "ui-addon-video-player": "static-1.9057",
  "ui-coaching-tips": "static-1.29506",
  "usage-tracker": "static-1.7731",
  "cms-field-types": "static-1.5230",
  "content-icons-ui": "static-1.2417",
  "integrations-lib": "static-1.17300",
  "customer-data-objects": "static-1.8112",
  "apollo-dlb": "static-3.98",
  "breeze-engine-lib": "static-1.2006",
  "apollo-link-hub-http": "static-2.5020",
  "apollo-stack-hubspot": "static-3.98",
  "graphql": "static-1.92",
  "immer": "static-1.104",
  "immerable": "static-1.4559",
  "poll-commands": "static-1.3890",
  "ui-addon-iframeable": "static-1.9495",
  "video-components-external": "static-1.12330",
  "video-data-lib": "static-1.35988",
  "breeze-artifacts-sdk": "static-1.680",
  "audio-components": "static-1.6492",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29976",
  "FileManagerImages": "static-1.37893",
  "foundations-components-legacy": "static-1.1683",
  "html-to-image": "static-1.64",
  "redux-toolkit": "static-1.81",
  "salesImages": "static-1.676",
  "ui-universal-auth": "static-1.9620",
  "urlinator": "static-1.4934",
  "video-components": "static-1.14332",
  "video-embed": "static-1.36822",
  "ts-schema": "static-1.4363",
  "ContentData": "static-1.69419",
  "layout-data-lib": "static-1.10433",
  "react-dnd-compat": "static-1.5029",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1964",
  "external-options-client-types": "static-1.4412",
  "fast-json-stable-stringify": "static-1.4",
  "hs-promise-utils": "static-1.6007",
  "hs-resources": "static-1.613",
  "inbound-db-properties-service-client": "static-1.4111",
  "NamespacedHubStyle": "static-2.9327",
  "growth-onboarding-confetti": "static-1.3482",
  "SharedI18nStrings": "static-1.186",
  "ui-addon-i18n": "static-1.11564",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5853",
  "magpie-types": "static-1.5313",
  "simple-logging-lib": "static-1.3470",
  "avatar-components": "static-1.2900",
  "customer-data-ui-utilities": "static-1.10250",
  "growth-onboarding-feedback-components": "static-1.7000",
  "flux-actions": "static-1.379",
  "hubspot-apollo-client": "static-1.5292",
  "integrations-error-boundary-lib": "static-1.14715",
  "integrations-tracking-lib": "static-1.6029",
  "laboratory-lib": "static-3.7568",
  "native-integrations-shared-strings": "static-1.8180",
  "redux-observable": "static-1.78",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10692",
  "unified-auth": "static-1.1134",
  "breeze-engine-chat-components": "static-1.984",
  "breeze-engine-core": "static-1.1284",
  "ably": "static-2.2",
  "highlight.js": "static-1.89",
  "pulse": "static-1.1056",
  "navigation-messaging": "static-1.8386",
  "content-media-composition-data-lib": "static-1.13478",
  "content-media-compositions": "static-2.17485",
  "idb-keyval": "static-1.54",
  "media-bridge-lib": "static-1.19558",
  "nudge-client-utils": "static-1.3317",
  "unified-auth-core-lib": "static-1.1416",
  "social-insights-client-types": "static-1.22835",
  "advanced-menus-core": "static-1.15731",
  "advanced-menus-lib": "static-1.12512",
  "ExportDialog": "static-6.10791",
  "ui-memberships-settings-lib": "static-1.35080",
  "conditional-properties-service-client": "static-1.4085",
  "crm-pipelines-api-client-types": "static-1.4416",
  "event-emitter": "static-1.1377",
  "framework-builder-read-service-client": "static-1.4291",
  "fdsr-migration-layer": "static-1.429",
  "inbound-db-meta-service-client": "static-1.3743",
  "multi-currency-client-types": "static-1.3980",
  "foundations-components-test-utils": "static-1.6141",
  "reactive-lib": "static-1.1141",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.751",
  "universal-page-editor-lib": "static-1.3427",
  "adobe-sign-auth-lib": "static-1.665",
  "ads-unified-auth-lib": "static-1.1769",
  "custom-vendor-connection-lib": "static-1.184",
  "google-sheets-integration-lib": "static-1.1230",
  "microsoft-drive-auth-lib": "static-1.392",
  "surveymonkey-integration-lib": "static-1.761",
  "slack-ui-library": "static-1.10814",
  "bend-plugin-pulse": "static-1.559",
  "fast-json-patch": "static-1.73",
  "js-cookie": "static-1.18",
  "nudge-custom-function-registry": "static-1.3074",
  "nudge-renderer-utils": "static-1.3393",
  "onboarding-tours": "static-1.17304",
  "whisper-core-api": "static-1.7535",
  "fsm": "static-1.4172",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15730",
  "simple-menus-lib": "static-1.17247",
  "settings-ui-lib": "static-1.12947",
  "persist-promise": "static-1.4121",
  "crm-record-cards-service-types": "static-1.3834",
  "framework-data-schema-resolvers": "static-1.7310",
  "location-customization-utils-lib": "static-1.10318",
  "getting-started-shared-tasks": "static-1.19463",
  "growth-data-modal": "static-1.6052",
  "growth-onboarding-next-action-utils": "static-1.2887",
  "navigation-components": "static-1.19059",
  "onboarding-tours-client": "static-1.5519",
  "onboarding-tours-utils": "static-1.1371",
  "ui-shepherd-tracker": "static-1.8073",
  "user-context": "static-1.5478",
  "react-flip-move": "static-1.82",
  "framework-data-schema-quick-fetch": "static-1.7215",
  "onboarding-data-sync-lib": "static-1.2744",
  "growth-onboarding-next-action-components": "static-1.2915",
  "user-context-client": "static-1.4926",
  "nest": "static-1.652",
  "getting-started-shared-tasks-store": "static-1.18581",
  "InboxConnectUtils": "static-4.15749",
  "meetings-connect-utils-lib": "static-1.8033",
  "onboarding-scopes": "static-1.6869"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30935",
  "emoji-mart": "/emoji-mart/static-3.6",
  "feedback-schema": "/feedback-schema/static-1.55508",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8456",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "HubStyleTokens": "/HubStyleTokens/static-2.11908",
  "I18n": "/I18n/static-7.1692",
  "quartz": "/quartz/static-1.7590",
  "quartz-config": "/quartz-config/static-1.1368",
  "quartz-core": "/quartz-core/static-1.6809",
  "react-dlb": "/react-dlb/static-1.92",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.83",
  "reselect": "/reselect/static-3.15",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.1039",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55495",
  "feedback-utils": "/feedback-utils/static-1.55499",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4882",
  "forms-utils-lib": "/forms-utils-lib/static-1.13250",
  "foundations-assets": "/foundations-assets/static-1.5303",
  "foundations-components": "/foundations-components/static-1.8658",
  "foundations-theming": "/foundations-theming/static-1.4899",
  "hub-http": "/hub-http/static-1.6626",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyle": "/HubStyle/static-2.12215",
  "icons": "/icons/static-2.699",
  "immutable": "/immutable/static-2.88",
  "quick-fetch": "/quick-fetch/static-1.4194",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.202",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.80",
  "react-rhumb": "/react-rhumb/static-1.17150",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5626",
  "react-virtualized": "/react-virtualized/static-2.111",
  "redux": "/redux/static-4.81",
  "StyleGuideUI": "/StyleGuideUI/static-3.513",
  "tinymce-plugins": "/tinymce-plugins/static-1.58410",
  "transmute": "/transmute/static-2.97",
  "ui-images": "/ui-images/static-2.1269",
  "UIComponents": "/UIComponents/static-3.8854",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9990",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3867",
  "quartz-webpack": "/quartz-webpack/static-1.3814",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2615",
  "property-description-translator": "/property-description-translator/static-1.4238",
  "HeadJS": "/HeadJS/static-2.812",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3567",
  "msw": "/msw/static-1.39",
  "msw-config": "/msw-config/static-1.19",
  "testing-library": "/testing-library/static-1.163",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.233",
  "moment-timezone": "/moment-timezone/static-5.94",
  "jasmine": "/jasmine/static-4.4726",
  "jasmine-runner": "/jasmine-runner/static-1.6867",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1-aeastham-default-document-load-user-interaction.5",
  "dispatcher": "/dispatcher/static-1.146",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.897",
  "hubspotter-http": "/hubspotter-http/static-1.4931",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.595",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1-aeastham-default-document-load-user-interaction.5",
  "quartz-auth": "/quartz-auth/static-1.1265",
  "quartz-head": "/quartz-head/static-1.1255",
  "quartz-i18n": "/quartz-i18n/static-1.1265",
  "quartz-routing": "/quartz-routing/static-1.1020",
  "quartz-test": "/quartz-test/static-1.1265",
  "quartz-tracking": "/quartz-tracking/static-1.969",
  "trellis-components": "/trellis-components/static-1.2971",
  "ui-fonts": "/ui-fonts/static-1.1170",
  "usage-tracker-container": "/usage-tracker-container/static-1.7721",
  "usage-tracker-core": "/usage-tracker-core/static-1.7581",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.306",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7602",
  "reference-resolvers": "/reference-resolvers/static-1.8596",
  "sanitize-text": "/sanitize-text/static-1.8575",
  "PatternValidationJS": "/PatternValidationJS/static-1.3304",
  "ReduxMessenger": "/ReduxMessenger/static-2.10789",
  "outpost": "/outpost/static-1.4552",
  "rpc-client-utils": "/rpc-client-utils/static-1.5087",
  "sanitize": "/sanitize/static-1.4891",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4927",
  "floating-ui": "/floating-ui/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9842",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.89",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.2952",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3382",
  "foundations-theming-base": "/foundations-theming-base/static-1.3884",
  "stylex": "/stylex/static-1.45",
  "hs-locale-management": "/hs-locale-management/static-1.364",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.18",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9923",
  "atom": "/atom/static-1.5495",
  "codemirror": "/codemirror/static-5.105",
  "content-assistance-lib": "/content-assistance-lib/static-1.8345",
  "ContentUtils": "/ContentUtils/static-1.69344",
  "data-token-picker": "/data-token-picker/static-1.17043",
  "file-manager-components": "/file-manager-components/static-1.24742",
  "FileManagerCore": "/FileManagerCore/static-1.40241",
  "FileManagerLib": "/FileManagerLib/static-1.40382",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8335",
  "hub-http-contrib": "/hub-http-contrib/static-1.3445",
  "interframe": "/interframe/static-3.5159",
  "layout-dnd-components": "/layout-dnd-components/static-1.13133",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12108",
  "property-translator": "/property-translator/static-1.5797",
  "react-codemirror": "/react-codemirror/static-1.11057",
  "react-colorpicker": "/react-colorpicker/static-2.10630",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8523",
  "rich-text-lib": "/rich-text-lib/static-1.20470",
  "tinymce-data": "/tinymce-data/static-1.41381",
  "tinymce-themes": "/tinymce-themes/static-1.57266",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10284",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5621",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16793",
  "bender-build-tools": "/bender-build-tools/static-1.3518",
  "opentelemetry-web": "/opentelemetry-web/static-1.18",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.117",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10807",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10805",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5417",
  "base-ui": "/base-ui/static-1.26",
  "react-day-picker": "/react-day-picker/static-1.14",
  "trellis-theming": "/trellis-theming/static-1.1401",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.497",
  "chirp-fetch": "/chirp-fetch/static-1.2318",
  "stylex-utils": "/stylex-utils/static-1.160",
  "chatspot-core": "/chatspot-core/static-1.23502",
  "copilot-toolkit": "/copilot-toolkit/static-1.12044",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13447",
  "data-fetching-client": "/data-fetching-client/static-1.10063",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5176",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9057",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29506",
  "usage-tracker": "/usage-tracker/static-1.7731",
  "cms-field-types": "/cms-field-types/static-1.5230",
  "content-icons-ui": "/content-icons-ui/static-1.2417",
  "integrations-lib": "/integrations-lib/static-1.17300",
  "customer-data-objects": "/customer-data-objects/static-1.8112",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2006",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5020",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.98",
  "graphql": "/graphql/static-1.92",
  "immer": "/immer/static-1.104",
  "immerable": "/immerable/static-1.4559",
  "poll-commands": "/poll-commands/static-1.3890",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9495",
  "video-components-external": "/video-components-external/static-1.12330",
  "video-data-lib": "/video-data-lib/static-1.35988",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.680",
  "audio-components": "/audio-components/static-1.6492",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29976",
  "FileManagerImages": "/FileManagerImages/static-1.37893",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1683",
  "html-to-image": "/html-to-image/static-1.64",
  "redux-toolkit": "/redux-toolkit/static-1.81",
  "salesImages": "/salesImages/static-1.676",
  "ui-universal-auth": "/ui-universal-auth/static-1.9620",
  "urlinator": "/urlinator/static-1.4934",
  "video-components": "/video-components/static-1.14332",
  "video-embed": "/video-embed/static-1.36822",
  "ts-schema": "/ts-schema/static-1.4363",
  "ContentData": "/ContentData/static-1.69419",
  "layout-data-lib": "/layout-data-lib/static-1.10433",
  "react-dnd-compat": "/react-dnd-compat/static-1.5029",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1964",
  "external-options-client-types": "/external-options-client-types/static-1.4412",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "hs-promise-utils": "/hs-promise-utils/static-1.6007",
  "hs-resources": "/hs-resources/static-1.613",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4111",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9327",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3482",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.186",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11564",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5853",
  "magpie-types": "/magpie-types/static-1.5313",
  "simple-logging-lib": "/simple-logging-lib/static-1.3470",
  "avatar-components": "/avatar-components/static-1.2900",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10250",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7000",
  "flux-actions": "/flux-actions/static-1.379",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5292",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14715",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6029",
  "laboratory-lib": "/laboratory-lib/static-3.7568",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8180",
  "redux-observable": "/redux-observable/static-1.78",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10692",
  "unified-auth": "/unified-auth/static-1.1134",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.984",
  "breeze-engine-core": "/breeze-engine-core/static-1.1284",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.89",
  "pulse": "/pulse/static-1.1056",
  "navigation-messaging": "/navigation-messaging/static-1.8386",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13478",
  "content-media-compositions": "/content-media-compositions/static-2.17485",
  "idb-keyval": "/idb-keyval/static-1.54",
  "media-bridge-lib": "/media-bridge-lib/static-1.19558",
  "nudge-client-utils": "/nudge-client-utils/static-1.3317",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1416",
  "social-insights-client-types": "/social-insights-client-types/static-1.22835",
  "advanced-menus-core": "/advanced-menus-core/static-1.15731",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12512",
  "ExportDialog": "/ExportDialog/static-6.10791",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35080",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4085",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4416",
  "event-emitter": "/event-emitter/static-1.1377",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4291",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.429",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3743",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3980",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6141",
  "reactive-lib": "/reactive-lib/static-1.1141",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.751",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3427",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.665",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1769",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.184",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1230",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.392",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.761",
  "slack-ui-library": "/slack-ui-library/static-1.10814",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.559",
  "fast-json-patch": "/fast-json-patch/static-1.73",
  "js-cookie": "/js-cookie/static-1.18",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3074",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3393",
  "onboarding-tours": "/onboarding-tours/static-1.17304",
  "whisper-core-api": "/whisper-core-api/static-1.7535",
  "fsm": "/fsm/static-1.4172",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15730",
  "simple-menus-lib": "/simple-menus-lib/static-1.17247",
  "settings-ui-lib": "/settings-ui-lib/static-1.12947",
  "persist-promise": "/persist-promise/static-1.4121",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3834",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7310",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10318",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19463",
  "growth-data-modal": "/growth-data-modal/static-1.6052",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2887",
  "navigation-components": "/navigation-components/static-1.19059",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5519",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1371",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8073",
  "user-context": "/user-context/static-1.5478",
  "react-flip-move": "/react-flip-move/static-1.82",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7215",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2744",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2915",
  "user-context-client": "/user-context-client/static-1.4926",
  "nest": "/nest/static-1.652",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18581",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15749",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8033",
  "onboarding-scopes": "/onboarding-scopes/static-1.6869"
}
};
